<template>
  <b-row>
    <b-col v-if="!forLogo">
      <h4>{{ headerText }}</h4>
      <vue-dropzone
        v-if="show"
        class="m-2"
        ref="myVueDropzone"
        id="dropzone"
        :options="dropzoneOptions"
        @vdropzone-processing="processing"
        @vdropzone-removed-file="removed"
        :destroyDropzone="false"
        @vdropzone-success="success"
        @vdropzone-error="doError"
        @vdropzone-queue-complete="allComplete"
        :useCustomSlot="true"
      >
        <div class="dropzone-custom-content">
          <h3 class="dropzone-custom-title">คลิกเพื่ออัพโหลดไฟล์</h3>
        </div>
      </vue-dropzone>
      <!-- <b-button v-on:click="doUpload" variant="primary">อัพโหลดไฟล์</b-button> -->
    </b-col>
    <b-col sm="12" v-else>
      <vue-dropzone
        v-if="show"
        class="m-2"
        ref="myVueDropzone"
        id="dropzone-logo"
        :options="dropzoneOptionsLogo"
        @vdropzone-processing="processing"
        @vdropzone-removed-file="removed"
        :destroyDropzone="false"
        @vdropzone-success="success"
        @vdropzone-error="doError"
        @vdropzone-queue-complete="allComplete"
        :useCustomSlot="true"
      >
        <div class="dropzone-custom-content">
          <div class="subtitle">อัพโหลดโลโก้</div>
        </div>
      </vue-dropzone>
    </b-col>
  </b-row>
</template>
<style>
#dropzone-logo {
  background-color: #1c4862;
  color: white;
  width: 50%;
  max-width: 200px;
  min-height: 0px !important;
  margin: auto !important;
}
#dropzone-logo .dz-preview {
    display: none;
  }
#dropzone-logo .dz-message {
    margin: 0;
  }
</style>

<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import HttpDoc from '../services/http/Doc'

export default {
  name: 'UploadDoc',
  props: {
    docType: {
      type: String,
      required: true
    },
    refId: {
      type: String,
      required: false
    },
    queueOption: {
      type: Boolean,
      default: true,
      required: false
    },
    headerText: {
      type: String,
      default: 'อัพโหลดเอกสาร',
      required: false
    },
    acceptedFiles: {
      type: String,
      default: 'image/jpeg,image/png,application/pdf',
      required: false
    },
    forLogo: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  components: {
    vueDropzone: vue2Dropzone
  },
  data () {
    return {
      dropzoneOptions: {
        url: process.env.VUE_APP_LOGISTY_API_HOST_NAME,
        headers: {
          'authorization': 'Bearer ' + window.$cookies.get('token')
        },
        addRemoveLinks: true,
        autoProcessQueue: this.queueOption,
        acceptedFiles: this.acceptedFiles
      },
      dropzoneOptionsLogo: {
        url: process.env.VUE_APP_LOGISTY_API_HOST_NAME,
        headers: {
          'authorization': 'Bearer ' + window.$cookies.get('token')
        },
        autoProcessQueue: this.queueOption,
        acceptedFiles: 'image/jpeg,image/png',
        maxFiles: 1,
        createImageThumbnails: false
      },
      show: true,
      objectRefId: null
    }
  },
  mounted () {
    this.objectRefId = this.refId
    Window.Event.$on('doUploadQueue-' + this.docType, (value) => {
      this.objectRefId = value
      this.doUpload()
    })
  },
  beforeDestroy () {
    Window.Event.$off('doUploadQueue-' + this.docType)
  },
  methods: {
    processing (file) {
      // console.log(file)
      // console.log(this.$refs.myVueDropzone)
      var httpDoc = new HttpDoc(this.docType, this.objectRefId)
      // console.log(httpDoc.getUrlImg())
      // console.log(httpDoc.getUrlPdf())
      if (file.type == 'application/pdf') {
        this.$refs.myVueDropzone.setOption('url', httpDoc.getUrlPdf())
      } else {
        this.$refs.myVueDropzone.setOption('url', httpDoc.getUrlImg())
      }
    },
    async removed (file) {
      // console.log(file.xhr)
      // console.log(file.xhr.status)
      // var responsive
      // if (file.status === 'error') {
      //   return
      // }
      // var xhr = file.xhr
      // var status = xhr.status
      // if (status == 200) {
      //   // do delete from server
      //   var response = JSON.parse(xhr.response)
      //   var httpDoc = new HttpDoc(this.docType, this.refId)
      //   try {
      //     await httpDoc.deleteDoc(response.data)
      //   } catch (error) {
      //     console.log(error)
      //   }
      // }
    },
    success (file) {
      this.makeToast('success', file.name, 'อัพโหลดสำเร็จ')
      this.$refs.myVueDropzone.removeFile(file)
    },
    doError (file, message) {
      this.makeToast('danger', file.name, message)
      this.$refs.myVueDropzone.removeFile(file)
    },
    makeToast (variant = 'success', title = '', content = '') {
      this.$bvToast.toast(content, {
        title: title,
        variant: variant,
        solid: true
      })
    },
    doUpload () {
      // console.log(this.refId)
      this.$refs.myVueDropzone.processQueue()
    },
    allComplete () {
      Window.Event.$emit('reloadDoc-' + this.docType)
    }
  }
}
</script>
